<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title">
      {{ 'Send %type%' | translate: { type: typeName } }}
    </h4>
    <button type="button" class="close" aria-label="Close" (click)="onClose()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-sm-12">
        <form novalidate (ngSubmit)="onSend()" [formGroup]="emailForm">
          <div class="form-group">
            <label for="recipients" class="control-label font-weight-bold">
              {{ 'Recipients' | translate }} *
            </label>
            <input
              type="text"
              class="form-control data-hj-whitelist"
              id="recipients"
              [class.is-invalid]="
                sent && emailForm.get('recipients').hasError('required')
              "
              formControlName="recipients"
              #email
            />
            <span class="text-muted pull-right">{{
              'separate multiple addresses with a comma.' | translate
            }}</span>

            <span
              class="invalid-feedback"
              *ngIf="sent && emailForm.get('recipients').hasError('required')"
            >
              {{ 'global.validators.required.error' | translate }}</span
            >
          </div>

          <div class="form-group">
            <label for="subject" class="control-label font-weight-bold">
              {{ 'Subject' | translate }} *
            </label>
            <input
              type="text"
              class="form-control data-hj-whitelist"
              id="subject"
              formControlName="subject"
            />
          </div>

          <div class="form-group">
            <label for="message" class="control-label font-weight-bold">
              {{ 'Message' | translate }}
            </label>
            <textarea
              rows="9"
              class="form-control data-hj-whitelist"
              id="message"
              [class.is-invalid]="
                sent && emailForm.get('message').hasError('required')
              "
              formControlName="message"
            ></textarea>

            <span
              class="invalid-feedback"
              *ngIf="sent && emailForm.get('message').hasError('required')"
            >
              {{ 'global.validators.required.error' | translate }}</span
            >
          </div>

          <p class="text-right small mt-0">
            {{ 'You can customize the default text in settings.' | translate }}
          </p>

          <div class="row">
            <div class="col-sm-6">
              <p class="font-weight-bold">{{ 'Attachments' | translate }}:</p>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="documentAttachment"
                  [checked]="true"
                  disabled
                />
                <label class="form-check-label" for="documentAttachment">
                  {{ attachmentName }} - {{ attachmentLanguage }}.pdf
                </label>
              </div>

              <div
                class="form-check pointer"
                *ngIf="document?.type === 'invoice'"
              >
                <input
                  class="form-check-input"
                  formControlName="eslogAttachment"
                  [class.text-muted]="!document.isValidEslog"
                  type="checkbox"
                  id="eslogAttachment"
                />
                <label class="form-check-label" for="eslogAttachment"
                  >{{ 'Eslog' | translate }}
                  <i
                    *ngIf="!document.isValidEslog"
                    class="fe fe-info"
                    ngbTooltip="{{
                      'Eslog standard file attachment not possible, document is missing mandatory data'
                        | translate
                    }}"
                  ></i>
                </label>
              </div>

              <div
                class="form-check pointer"
                *ngFor="let attachment of attachments"
              >
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="{{ attachment.id }}"
                  [(ngModel)]="attachment.value"
                  [ngModelOptions]="{ standalone: true }"
                />
                <label class="form-check-label" for="{{ attachment.id }}">{{
                  attachment.nameOriginal
                }}</label>
              </div>
            </div>
            <div class="col-sm-6 text-right">
              <p class="font-weight-bold">
                {{ 'documents.email-document.language.label' | translate }}:
              </p>
              <span
                class="dropdown"
                ngbDropdown
                container="body"
                placement="top-right"
              >
                <a
                  style="cursor: pointer"
                  (click)="(false)"
                  class="dropdown-toggle"
                  aria-haspopup="true"
                  aria-expanded="false"
                  data-toggle="dropdown"
                  ngbDropdownToggle
                  data-boundary="viewport"
                >
                  <ng-container *ngFor="let l of locales">
                    <ng-container *ngIf="attachmentLanguage === l.symbol">
                      <ng-container
                        *ngIf="
                          l.symbol !== activeOrg.locale.split('-')[0];
                          else defaultLocale
                        "
                      >
                        <i class="fi fi-{{ l.flag }}"></i>
                        {{ l.name | translate }}
                      </ng-container>
                      <ng-template #defaultLocale>
                        <i class="fe fe-flag"></i>
                        {{
                          'documents.email-document.language.default'
                            | translate
                        }}
                      </ng-template>
                    </ng-container>
                  </ng-container>
                </a>

                <div class="dropdown-menu language-select" ngbDropdownMenu>
                  <div
                    *ngFor="let l of locales"
                    class="dropdown-item pointer"
                    (click)="onChangeLanguage(l.symbol); (false)"
                  >
                    <ng-container
                      *ngIf="l.symbol !== activeOrg.locale.split('-')[0]; else defaultLocale"
                    >
                      <i
                        class="fi fi-{{
                          l.flag
                        }} flag-icon-squared"
                      ></i>
                      {{ l.name | translate }}
                    </ng-container>
                    <ng-template #defaultLocale>
                      <i class="fe fe-flag"></i>
                      {{
                        'documents.email-document.language.default' | translate
                      }}
                    </ng-template>
                  </div>
                </div>
              </span>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-auto ml-auto">
              <div class="checkbox text-right">
                <label>
                  <input type="checkbox" formControlName="sendCopy" />
                  {{ 'Send me a copy' | translate }}
                </label>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button class="btn btn-outline-secondary" type="button" (click)="onClose()">
      {{ 'Cancel' | translate }}
    </button>
    <button class="btn btn-outline-primary" type="button" (click)="onSend()">
      {{ 'Send' | translate }}
      <span *ngIf="loading"
        >&nbsp; <i class="fa fa-spinner-third fa-spin fa-md fa-lg"></i
      ></span>
    </button>
  </div>
</div>
